module.exports = __webpack_public_path__ + "img/3.ed6eb35b.png";